import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  HostListener,
} from '@angular/core';
import { ProgressNavShared } from '../shared/progress-nav-shared';
import { Subscription } from 'rxjs';
import { RegisterShared } from '../shared/register-shared';
import { GenerateShared } from '../shared/generate-shared';

@Component({
  selector: 'app-progress-nav',
  templateUrl: './progress-nav.component.html',
  styleUrls: ['./progress-nav.component.scss'],
})
export class ProgressNavComponent implements OnInit, OnDestroy {
  @Input() totalSteps;

  currentStep = 1;

  subscription1: Subscription;
  subscription2: Subscription;
  subscription3: Subscription;
  subscription4: Subscription;

  constructor(
    private progressNavShared: ProgressNavShared,
    private registerShared: RegisterShared,
    private generateShared: GenerateShared
  ) {
    this.subscription1 = this.generateShared.nextPageObs$.subscribe(
      (clicked) => {
        if (clicked) {
          this.nextStep();
        }
      }
    );
    this.subscription2 = this.registerShared.nextPageObs$.subscribe(
      (clicked) => {
        if (clicked) {
          this.nextStep();
        }
      }
    );
    this.subscription3 =
      this.progressNavShared.progressNavShowBackButtonObs$.subscribe((show) => {
        if (show) {
          this.animateShowBackButton();
        }
      });

    this.subscription4 =
      this.progressNavShared.progressNavHideBackButtonObs$.subscribe((hide) => {
        if (hide) {
          this.animateHideBackButton();
        }
      });
  }

  ngOnInit() {
    this.animateProgressBar();
  }

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    this.subscription3.unsubscribe();
    this.subscription4.unsubscribe();
  }

  nextStep() {
    if (this.currentStep < this.totalSteps) {
      this.currentStep++;
      this.animateProgressBar();
    }
  }

  previousStep() {
    if (this.currentStep > 1) {
      this.currentStep--;
      this.animateProgressBar();
    }
  }

  animateProgressBar() {
    document.getElementById('progressBar').style.width =
      ((this.currentStep * 100) / this.totalSteps).toString() + '%';
  }

  animateShowBackButton() {
    document.getElementById('backHolder').style.right = '8px';
  }

  animateHideBackButton() {
    document.getElementById('backHolder').style.right = '-35px';
  }

  backClicked() {
    this.previousStep();
    this.progressNavShared.progressNavPreStep();
  }
}
